import React from 'react';
import './project.css';
import { Outlet } from 'react-router-dom';

const Project = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default Project;
